module.exports = __webpack_public_path__ + "img/picturetext.38da0ede.png";